import { Button, Skeleton } from "@mui/material";
import jsPDF from "jspdf";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Logo from "../../assets/pdf logo.png";
import ApiService from "../../services/ApiService";
import { dbToDate, dbToTime } from "../../utils/dateTime";
import { formatCurrency } from "../../utils/formatCurrency";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const LKPToPDF = ({ id }) => {
  // const { id } = useParams();

  // Fetch Form LKP Initial Value
  const [inputFields, setInputFields] = useState({});
  const [onLoad, setOnLoad] = useState(true);
  const markdownTest =
    "**Just** test Test Kejadian <br/><br/> Test Kejadian 2\n\nTest Kejadian 3";
  useEffect(() => {
    const fetchEIC = async () => {
      var temp = [];
      var temp2 = [];

      try {
        await Promise.all(
          await ApiService.getIncimanLkp(id).then((res) => {
            var result = res.data.payload;
            setInputFields(result);
            console.log("result", result);

            sortListAllKategoriInsiden(result.listAllKategoriInsiden);
            countEstimateImpact(result.listDetailEstimateContent);

            getDataUnit();
            getDataRegion();
            getDataLokasi(result.idRegional);
          }),
          await ApiService.getIncimanLkp("MA==").then((res) => {
            var result = res.data.payload;

            temp = result.listDetailEstimateImpact;

            setOnLoad(false);
          }),
          temp.forEach(async (dEI) => {
            // Get Header Estimate Impact
            await ApiService.getEstimateImpactContent(
              dEI.detailEstimateImpactId
            ).then((res2) => {
              temp2.push(...res2.data.payload);
            });
          })
        );
      } catch (error) {}
    };

    fetchEIC();
  }, []);

  // Sort listAllKategoriInsiden
  const [loadKI, setLoadKI] = useState(true);

  const [id1, setId1] = useState(null);
  const [id2, setId2] = useState(null);
  const [id3, setId3] = useState(null);
  const [id4, setId4] = useState(null);
  const [id5, setId5] = useState(null);
  const [id6, setId6] = useState(null);

  const [count1, setCount1] = useState(null);
  const [count2, setCount2] = useState(null);

  const sortListAllKategoriInsiden = (data) => {
    let d1 = data.filter(
      (item) => item.kategoriInsidenId === 1 && item.isCheked === true
    );
    let d2 = data.filter(
      (item) => item.kategoriInsidenId === 2 && item.isCheked === true
    );
    let d3 = data.filter(
      (item) => item.kategoriInsidenId === 3 && item.isCheked === true
    );
    let d4 = data.filter(
      (item) => item.kategoriInsidenId === 4 && item.isCheked === true
    );
    let d5 = data.filter(
      (item) => item.kategoriInsidenId === 5 && item.isCheked === true
    );
    let d6 = data.filter(
      (item) => item.kategoriInsidenId === 6 && item.isCheked === true
    );

    let maxCount1 = Math.max(d1.length, d2.length, d3.length);
    let maxCount2 = Math.max(d4.length, d5.length, d6.length);

    let temp1 = [];
    for (let index = 0; index < maxCount1; index++) {
      temp1.push({ idx: index });
    }

    console.log("temp1", temp1);
    setCount1(temp1);

    let temp2 = [];
    for (let index = 0; index < maxCount2; index++) {
      temp2.push({ idx: index });
    }
    console.log("temp2", temp2);

    setCount2(temp2);

    setId1(d1);
    setId2(d2);
    setId3(d3);
    setId4(d4);
    setId5(d5);
    setId6(d6);

    setLoadKI(false);
    return true;
  };

  // Max Estimate Impact
  const [maxEI, setMaxEI] = useState(0);
  const countEstimateImpact = (data) => {
    let maxCount = 0;
    maxCount = data.length;

    for (let index = 1; index <= 6; index++) {
      if (
        data.findIndex((item) => item.detailEstimateImpactId === index) > -1
      ) {
        maxCount++;
      }
    }

    setMaxEI(maxCount);

    return true;
  };

  // MASTER LOCATION
  const [dataRegion, setDataRegion] = useState([]);
  const [dataUnit, setDataUnit] = useState([]);
  const [dataLokasi, setDataLokasi] = useState([]);

  //   Master Unit, Region, Lokasi
  const getDataUnit = () => {
    ApiService.getMsUnit().then((res) => {
      var result = res.data.payload;
      setDataUnit(result);
    });
  };
  const getDataRegion = () => {
    ApiService.getMsRegional().then((res) => {
      var result = res.data.payload;
      setDataRegion(result);
    });
  };
  const getDataLokasi = (id) => {
    ApiService.getMsLokasi(id).then((res) => {
      var result = res.data.payload;
      setDataLokasi(result);
    });
  };

  const generatePDF = () => {
    var doc = new jsPDF("p", "px", [1267, 2850]);

    doc.html(document.querySelector("#page"), {
      callback: function (pdf) {
        pdf.save(`${inputFields.noLkp}.pdf`);
      },
    });
  };

  return (
    <div>
      {/* <br />
      <Button
        onClick={generatePDF}
        variant="contained"
        style={styles.btnExport}
      >
        Export
      </Button>
      <br /> */}

      <div id="page" style={styles.page}>
        <div style={styles.header}>
          <span style={styles.title}>LAPORAN KEJADIAN PENTING</span>
          <img src={Logo} alt="pertamina" style={styles.logo} />
        </div>

        {onLoad && (
          <Skeleton style={styles.table} height={"70vh"} animation="wave" />
        )}

        {!onLoad && (
          <table style={styles.table}>
            <tbody>
              {/* Header */}
              <>
                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1}>
                    Kepada Yth :
                  </td>
                  <td style={styles.td} colSpan={11}>
                    {inputFields.listKepadas.map((item, idx) => (
                      <>
                        {item.seq}. {item.jabatanUser} <br></br>
                      </>
                    ))}
                  </td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1}>
                    No. LKP :
                  </td>
                  <td style={styles.td} colSpan={3}>
                    {inputFields.noLkp}
                  </td>
                  <td style={styles.td} colSpan={2}>
                    Judul Laporan :
                  </td>
                  <td style={styles.td} colSpan={4}>
                    {inputFields.judulLaporan}
                  </td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1}>
                    Unit Bisnis :
                  </td>
                  <td style={styles.td} colSpan={3}>
                    {/* Unit Bisnis */}
                    {
                      dataUnit.find(
                        (item) => item.id === inputFields.idUnitBisnis
                      ).name
                    }
                  </td>

                  <td style={styles.td} colSpan={2}>
                    Waktu Kejadian :
                  </td>
                  <td style={styles.td} colSpan={4}>
                    {dbToTime(inputFields.waktuKejadian)} Local Time
                  </td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1}>
                    Regional :
                  </td>
                  <td style={styles.td} colSpan={3}>
                    {/* Regional */}
                    {
                      dataRegion.find(
                        (item) => item.id === inputFields.idRegional
                      ).name
                    }
                  </td>
                  <td style={styles.td} colSpan={2}>
                    Tgl. Kejadian :
                  </td>
                  <td style={styles.td} colSpan={4}>
                    {dbToDate(inputFields.tglKejadian)}
                  </td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1}>
                    Lokasi :
                  </td>
                  <td style={styles.td} colSpan={3}>
                    {/* Lokasi */}
                    {
                      dataLokasi.find(
                        (item) => item.id === inputFields.idLokasi
                      ).name
                    }
                  </td>
                  <td style={styles.td} colSpan={2}>
                    Tgl. Laporan :
                  </td>
                  <td style={styles.td} colSpan={4}>
                    {dbToDate(inputFields.tglLaporan)}
                  </td>
                </tr>
              </>

              {/* Informasi Kejadian */}

              <>
                <tr style={styles.tr}>
                  <td colSpan={14} style={styles.subtitle}>
                    INFORMASI KEJADIAN
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1}>
                    Deskripsi Singkat Kejadian:
                  </td>
                  <td style={styles.td} colSpan={11}>
                    <ReactMarkdown
                      children={inputFields.deskripsiSingkat.replaceAll(
                        "\n",
                        "<br />"
                      )}
                      rehypePlugins={[rehypeRaw]}
                    />
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1}>
                    Titik Koordinat :
                  </td>
                  <td style={styles.td} colSpan={2}>
                    {inputFields.locationTagLat}, {inputFields.locationTagLong}
                  </td>
                  <td style={styles.td} colSpan={2}>
                    {inputFields.namaLokasiOnMap}
                  </td>

                  <td style={styles.td} colSpan={2}>
                    Perusahaan terlibat :
                  </td>
                  <td style={styles.td} colSpan={4}>
                    {inputFields.perusahaanTerlibat}
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1}>
                    Kategori Hipo :
                  </td>
                  <td style={styles.td} colSpan={3}>
                    <input
                      type="checkbox"
                      disabled
                      checked={inputFields.isHipo}
                    />{" "}
                    HIPO
                  </td>

                  <td style={styles.td} colSpan={7}>
                    <input
                      type="checkbox"
                      disabled
                      checked={!inputFields.isHipo}
                    />{" "}
                    NON - HIPO
                  </td>
                </tr>
              </>

              {/* Kategori Insiden */}
              <>
                <tr style={styles.tr}>
                  <td
                    style={styles.td}
                    colSpan={1}
                    rowSpan={count1.length + count2.length + 3}
                  >
                    Kategori Insiden
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={2}>
                    <input
                      type="checkbox"
                      disabled
                      checked={
                        inputFields.listAllKategoriInsiden.findIndex(
                          (item) =>
                            item.kategoriInsidenId === 1 &&
                            item.isCheked === true
                        ) > -1
                      }
                    />{" "}
                    <b>Keselamatan & Kesehatan Kerja</b>
                  </td>

                  <td style={styles.td} colSpan={3}>
                    <input
                      type="checkbox"
                      disabled
                      checked={
                        inputFields.listAllKategoriInsiden.findIndex(
                          (item) =>
                            item.kategoriInsidenId === 2 &&
                            item.isCheked === true
                        ) > -1
                      }
                    />{" "}
                    <b>Kerusakan Properti</b>
                  </td>
                  <td style={styles.td} colSpan={4}>
                    <input
                      type="checkbox"
                      disabled
                      checked={
                        inputFields.listAllKategoriInsiden.findIndex(
                          (item) =>
                            item.kategoriInsidenId === 3 &&
                            item.isCheked === true
                        ) > -1
                      }
                    />{" "}
                    <b>Keselamatan Proses</b>
                  </td>
                </tr>

                {!loadKI &&
                  count1.map((item) => (
                    <tr style={styles.tr} key={item.idx}>
                      <td style={styles.td} colSpan={2}>
                        {id1[item.idx]?.detailKategoriInsidenName ? (
                          <>
                            <input
                              type="checkbox"
                              disabled
                              name="hipo"
                              id="hipo"
                              defaultChecked={id1[item.idx]?.isCheked}
                            />
                            {id1[item.idx].detailKategoriInsidenName}
                          </>
                        ) : (
                          <></>
                        )}
                      </td>
                      <td style={styles.td} colSpan={3}>
                        {id2[item.idx]?.detailKategoriInsidenName ? (
                          <>
                            <input
                              type="checkbox"
                              disabled
                              name="hipo"
                              id="hipo"
                              defaultChecked={id2[item.idx]?.isCheked}
                            />
                            {id2[item.idx].detailKategoriInsidenName}
                          </>
                        ) : (
                          <></>
                        )}
                      </td>
                      <td style={styles.td} colSpan={4}>
                        {id3[item.idx]?.detailKategoriInsidenName ? (
                          <>
                            <input
                              type="checkbox"
                              disabled
                              name="hipo"
                              id="hipo"
                              defaultChecked={id3[item.idx]?.isCheked}
                            />
                            {id3[item.idx].detailKategoriInsidenName}
                          </>
                        ) : (
                          <></>
                        )}
                      </td>
                    </tr>
                  ))}

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={2}>
                    <input
                      type="checkbox"
                      disabled
                      checked={
                        inputFields.listAllKategoriInsiden.findIndex(
                          (item) =>
                            item.kategoriInsidenId === 4 &&
                            item.isCheked === true
                        ) > -1
                      }
                    />{" "}
                    <b>Kecelakaan Transportasi</b>
                  </td>

                  <td style={styles.td} colSpan={3}>
                    <input
                      type="checkbox"
                      disabled
                      checked={
                        inputFields.listAllKategoriInsiden.findIndex(
                          (item) =>
                            item.kategoriInsidenId === 5 &&
                            item.isCheked === true
                        ) > -1
                      }
                    />{" "}
                    <b>Security</b>
                  </td>
                  <td style={styles.td} colSpan={4}>
                    <input
                      type="checkbox"
                      disabled
                      checked={
                        inputFields.listAllKategoriInsiden.findIndex(
                          (item) =>
                            item.kategoriInsidenId === 6 &&
                            item.isCheked === true
                        ) > -1
                      }
                    />{" "}
                    <b>Lainnya</b>
                  </td>
                </tr>

                {!loadKI &&
                  count2.map((item) => (
                    <tr style={styles.tr} key={item.idx}>
                      <td style={styles.td} colSpan={2}>
                        {id4[item.idx]?.detailKategoriInsidenName ? (
                          <>
                            <input
                              type="checkbox"
                              disabled
                              name="hipo"
                              id="hipo"
                              defaultChecked={id4[item.idx]?.isCheked}
                            />
                            {id4[item.idx].detailKategoriInsidenName}
                          </>
                        ) : (
                          <></>
                        )}
                      </td>
                      <td style={styles.td} colSpan={3}>
                        {id5[item.idx]?.detailKategoriInsidenName ? (
                          <>
                            <input
                              type="checkbox"
                              disabled
                              name="hipo"
                              id="hipo"
                              defaultChecked={id5[item.idx]?.isCheked}
                            />
                            {id5[item.idx].detailKategoriInsidenName}
                          </>
                        ) : (
                          <></>
                        )}
                      </td>
                      <td style={styles.td} colSpan={4}>
                        {id6[item.idx]?.detailKategoriInsidenName ? (
                          <>
                            <input
                              type="checkbox"
                              disabled
                              name="hipo"
                              id="hipo"
                              defaultChecked={id6[item.idx]?.isCheked}
                            />
                            {id6[item.idx].detailKategoriInsidenName}
                          </>
                        ) : (
                          <></>
                        )}
                      </td>
                    </tr>
                  ))}

                {/* Kriteria Pencatatan Insiden */}
                <>
                  <tr style={styles.tr}>
                    <td style={styles.td} colSpan={1} rowSpan={3}>
                      Kriteria Pencatatan
                    </td>
                    <td style={styles.td} colSpan={3}>
                      <input
                        type="checkbox"
                        disabled
                        name="hipo"
                        id="hipo"
                        checked={inputFields.isReportAble}
                      />{" "}
                      <b>Reportable</b>
                    </td>

                    <td style={styles.td} colSpan={5}>
                      <input
                        type="checkbox"
                        disabled
                        name="hipo"
                        id="hipo"
                        checked={!inputFields.isReportAble}
                      />{" "}
                      <b>Non Reportable</b>
                    </td>
                  </tr>

                  <tr style={styles.tr}>
                    <td style={styles.td} colSpan={3}>
                      <input
                        type="checkbox"
                        disabled
                        name="hipo"
                        id="hipo"
                        checked={inputFields.isWorkRelated}
                      />{" "}
                      <b>Work Related</b>
                    </td>

                    <td style={styles.td} colSpan={5}>
                      <input
                        type="checkbox"
                        disabled
                        name="hipo"
                        id="hipo"
                        checked={!inputFields.isWorkRelated}
                      />{" "}
                      <b>Non Work Related</b>
                    </td>
                  </tr>

                  <tr style={styles.tr}>
                    <td style={styles.td} colSpan={3}>
                      <input
                        type="checkbox"
                        disabled
                        name="hipo"
                        id="hipo"
                        checked={inputFields.isRecordAble}
                      />{" "}
                      <b>Recordable</b>
                    </td>

                    <td style={styles.td} colSpan={5}>
                      <input
                        type="checkbox"
                        disabled
                        name="hipo"
                        id="hipo"
                        checked={!inputFields.isRecordAble}
                      />{" "}
                      <b>Non Recordable</b>
                    </td>
                  </tr>
                </>
              </>

              {/* Estimate Impact */}
              <>
                <tr className="html2pdf__page-break"></tr>
                <tr style={styles.tr}>
                  <td colSpan={13} style={styles.subtitle}>
                    ESTIMATE IMPACT
                  </td>
                </tr>

                {/* Health And Safety */}
                <>
                  {inputFields.listDetailEstimateContent.findIndex(
                    (item) => item.detailEstimateImpactId === 1
                  ) > -1 && (
                    <>
                      {/* 1. */}
                      <tr style={styles.tr}>
                        <td style={styles.td} colSpan={1} rowSpan={maxEI + 1}>
                          Estimate Impact
                        </td>
                      </tr>

                      <tr style={styles.tr}>
                        <td
                          style={styles.td}
                          colSpan={1}
                          rowSpan={
                            inputFields.listDetailEstimateContent.filter(
                              (item) => item.detailEstimateImpactId === 1
                            ).length + 1
                          }
                        >
                          <input type="checkbox" disabled checked={true} />{" "}
                          Health And Safety
                        </td>

                        <td colSpan={2} style={styles.td}>
                          Kategori
                        </td>
                        <td colSpan={1} style={styles.td}>
                          Jumlah
                        </td>
                        <td colSpan={1} style={styles.td}>
                          Satuan
                        </td>
                        <td colSpan={2} style={styles.td}>
                          Type Pekerja
                        </td>
                        <td colSpan={2} style={styles.td}>
                          Keterangan
                        </td>
                      </tr>

                      {inputFields.listDetailEstimateContent.map(
                        (item, idx) =>
                          item.detailEstimateImpactId === 1 && (
                            <tr style={styles.tr} key={idx}>
                              <td colSpan={2} style={styles.td}>
                                <input
                                  type="checkbox"
                                  disabled
                                  checked={item.jumlahOrNilaiKerugian !== 0}
                                />
                                {item.detailContentEstimateImpactName}
                              </td>
                              <td colSpan={1} style={styles.td}>
                                {formatCurrency(item.jumlahOrNilaiKerugian)}
                              </td>
                              <td colSpan={1} style={styles.td}>
                                {item.satuan}
                              </td>
                              <td colSpan={2} style={styles.td}>
                                {item.tipePekerja === null
                                  ? ""
                                  : item.tipePekerja}
                              </td>
                              <td colSpan={2} style={styles.td}>
                                {item.keterangan === null
                                  ? ""
                                  : item.keterangan}
                              </td>
                            </tr>
                          )
                      )}
                    </>
                  )}
                </>

                {/* Environtment */}
                <>
                  {inputFields.listDetailEstimateContent.findIndex(
                    (item) => item.detailEstimateImpactId === 2
                  ) > -1 && (
                    <>
                      {/* 2. */}
                      <tr style={styles.tr}>
                        <td
                          style={styles.td}
                          colSpan={1}
                          rowSpan={
                            inputFields.listDetailEstimateContent.filter(
                              (item) => item.detailEstimateImpactId === 2
                            ).length + 1
                          }
                        >
                          <input type="checkbox" disabled checked={true} />{" "}
                          Environtment
                        </td>

                        <td colSpan={1} style={styles.td}>
                          Nama Produk
                        </td>
                        <td colSpan={1} style={styles.td}>
                          Tipe
                        </td>
                        <td colSpan={1} style={styles.td}>
                          Jumlah
                        </td>
                        <td colSpan={1} style={styles.td}>
                          Satuan
                        </td>
                        <td colSpan={1} style={styles.td}>
                          Nilai Konv.
                        </td>
                        <td colSpan={1} style={styles.td}>
                          Hasil
                        </td>
                        <td colSpan={2} style={styles.td}>
                          Keterangan
                        </td>
                      </tr>

                      {inputFields.listDetailEstimateContent.map(
                        (item, idx) =>
                          item.detailEstimateImpactId === 2 && (
                            <tr style={styles.tr} key={idx}>
                              <td colSpan={1} style={styles.td}>
                                <input
                                  type="checkbox"
                                  disabled
                                  checked={item.jumlahOrNilaiKerugian !== 0}
                                />
                                {item.detailContentEstimateImpactName}
                              </td>
                              <td colSpan={1} style={styles.td}>
                                {item.estimateImpactContentItemName}
                              </td>
                              <td colSpan={1} style={styles.td}>
                                {formatCurrency(
                                  parseFloat(
                                    item.jumlahOrNilaiKerugian
                                  ).toFixed(2)
                                )}
                              </td>
                              <td colSpan={1} style={styles.td}>
                                {item.satuan}
                              </td>
                              <td colSpan={1} style={styles.td}>
                                {parseFloat(item.konversiSatuan).toFixed(2)}
                              </td>
                              <td colSpan={1} style={styles.td}>
                                {formatCurrency(item.nilaiKonversi)}
                              </td>
                              <td colSpan={2} style={styles.td}>
                                {item.keterangan}
                              </td>
                            </tr>
                          )
                      )}
                    </>
                  )}
                </>

                {/* Financial Impact */}
                <>
                  {inputFields.listDetailEstimateContent.findIndex(
                    (item) =>
                      item.detailEstimateImpactId === 3 &&
                      item.jumlahOrNilaiKerugian !== 0
                  ) > -1 && (
                    <>
                      {/* 3. */}
                      <tr style={styles.tr}>
                        <td
                          style={styles.td}
                          colSpan={1}
                          rowSpan={
                            inputFields.listDetailEstimateContent.filter(
                              (item) => item.detailEstimateImpactId === 3
                            ).length + 1
                          }
                        >
                          <input type="checkbox" disabled checked={true} />{" "}
                          Financial Impact
                        </td>

                        <td colSpan={4} style={styles.td}>
                          Item
                        </td>
                        <td colSpan={1} style={styles.td}>
                          Nilai Kerugian
                        </td>
                        <td colSpan={1} style={styles.td}>
                          Satuan
                        </td>
                        <td colSpan={3} style={styles.td}>
                          Keterangan
                        </td>
                      </tr>

                      {inputFields.listDetailEstimateContent.map(
                        (item, idx) =>
                          item.detailEstimateImpactId === 3 && (
                            <tr style={styles.tr} key={idx}>
                              <td colSpan={4} style={styles.td}>
                                <input
                                  type="checkbox"
                                  disabled
                                  checked={item.jumlahOrNilaiKerugian !== 0}
                                />
                                {item.detailContentEstimateImpactName}
                              </td>
                              <td colSpan={1} style={styles.td}>
                                {item.jumlahOrNilaiKerugian === 0
                                  ? 0
                                  : formatCurrency(
                                      parseFloat(
                                        item.jumlahOrNilaiKerugian
                                      ).toFixed(2)
                                    )}
                              </td>
                              <td colSpan={1} style={styles.td}>
                                {item.satuan}
                              </td>
                              <td colSpan={3} style={styles.td}>
                                {item.keterangan === null
                                  ? ""
                                  : item.keterangan}
                              </td>
                            </tr>
                          )
                      )}
                    </>
                  )}
                </>

                {/* Reputation Impact And Legal */}
                <>
                  {inputFields.listDetailEstimateContent.findIndex(
                    (item) => item.detailEstimateImpactId === 4
                  ) > -1 && (
                    <>
                      {/* 4. */}
                      <tr style={styles.tr}>
                        <td
                          style={styles.td}
                          colSpan={1}
                          rowSpan={
                            inputFields.listDetailEstimateContent.filter(
                              (item) => item.detailEstimateImpactId === 4
                            ).length + 1
                          }
                        >
                          <input type="checkbox" disabled checked={true} />{" "}
                          Reputation Impact And Legal
                        </td>

                        <td colSpan={4} style={styles.td}>
                          Dampak Reputasi
                        </td>
                        <td colSpan={4} style={styles.td}>
                          Keterangan
                        </td>
                      </tr>

                      {inputFields.listDetailEstimateContent.map(
                        (item, idx) =>
                          item.detailEstimateImpactId === 4 && (
                            <tr style={styles.tr} key={idx}>
                              <td colSpan={4} style={styles.td}>
                                <input
                                  type="checkbox"
                                  disabled
                                  checked={true}
                                />
                                {item.detailContentEstimateImpactName}
                              </td>
                              <td colSpan={4} style={styles.td}>
                                {item.keterangan === null
                                  ? ""
                                  : item.keterangan}
                              </td>
                            </tr>
                          )
                      )}
                    </>
                  )}
                </>

                {/*  Asset And Equipment */}
                <>
                  {inputFields.listDetailEstimateContent.findIndex(
                    (item) => item.detailEstimateImpactId === 5
                  ) > -1 && (
                    <>
                      {/* 5. */}
                      <tr style={styles.tr}>
                        <td
                          style={styles.td}
                          colSpan={1}
                          rowSpan={
                            inputFields.listDetailEstimateContent.filter(
                              (item) => item.detailEstimateImpactId === 5
                            ).length + 1
                          }
                        >
                          <input type="checkbox" disabled checked={true} />{" "}
                          Asset And Equipment
                        </td>

                        <td colSpan={4} style={styles.td}>
                          Type of Asset and Equipment
                        </td>
                        <td colSpan={1} style={styles.td}>
                          Nilai Kerugian
                        </td>
                        <td colSpan={1} style={styles.td}>
                          Satuan
                        </td>
                        <td colSpan={3} style={styles.td}>
                          Keterangan
                        </td>
                      </tr>

                      {inputFields.listDetailEstimateContent.map(
                        (item, idx) =>
                          item.detailEstimateImpactId === 5 && (
                            <tr style={styles.tr} key={idx}>
                              <td colSpan={4} style={styles.td}>
                                <input
                                  type="checkbox"
                                  disabled
                                  checked={true}
                                />
                                {item.detailContentEstimateImpactName}
                              </td>
                              <td colSpan={1} style={styles.td}>
                                {formatCurrency(
                                  parseFloat(
                                    item.jumlahOrNilaiKerugian
                                  ).toFixed(2)
                                )}
                              </td>
                              <td colSpan={1} style={styles.td}>
                                {item.satuan}
                              </td>
                              <td colSpan={3} style={styles.td}>
                                {item.keterangan === null
                                  ? ""
                                  : item.keterangan}
                              </td>
                            </tr>
                          )
                      )}
                    </>
                  )}
                </>

                {/* Public Notification */}
                <>
                  {inputFields.listDetailEstimateContent.findIndex(
                    (item) => item.detailEstimateImpactId === 6
                  ) > -1 && (
                    <>
                      {/* 6. */}
                      <tr style={styles.tr}>
                        <td
                          style={styles.td}
                          colSpan={1}
                          rowSpan={
                            inputFields.listDetailEstimateContent.filter(
                              (item) => item.detailEstimateImpactId === 6
                            ).length + 1
                          }
                        >
                          <input type="checkbox" disabled checked={true} />
                          Public Notification
                        </td>

                        <td colSpan={4} style={styles.td}>
                          Public Notification
                        </td>
                        <td colSpan={4} style={styles.td}>
                          Keterangan
                        </td>
                      </tr>

                      {inputFields.listDetailEstimateContent.map(
                        (item, idx) =>
                          item.detailEstimateImpactId === 6 && (
                            <tr style={styles.tr} key={idx}>
                              <td colSpan={4} style={styles.td}>
                                <input
                                  type="checkbox"
                                  disabled
                                  checked={true}
                                />
                                {item.detailContentEstimateImpactName}
                              </td>
                              <td colSpan={4} style={styles.td}>
                                {item.keterangan === null
                                  ? ""
                                  : item.keterangan}
                              </td>
                            </tr>
                          )
                      )}
                    </>
                  )}
                </>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1}>
                    Severity :
                  </td>
                  <td style={styles.td} colSpan={9}>
                    {inputFields.potensiTingkatKeparahan}
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1}>
                    Probability :
                  </td>
                  <td style={styles.td} colSpan={9}>
                    {inputFields.probabilitasKejadian}
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={13}>
                    Keterangan *) Sesuai Pedoman Pengelolaan HSSE Berbasis
                    Risiko
                  </td>
                </tr>
              </>

              {/* Kemungkinan Penyebab */}
              <>
                <tr style={styles.tr}>
                  <td colSpan={13} style={styles.subtitle}>
                    KEMUNGKINAN PENYEBAB
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={2}>
                    Kemungkinan Penyebab Langsung :
                  </td>
                  <td style={styles.td} colSpan={10}>
                    <ReactMarkdown
                      children={inputFields.kemungkinanPenyebabLangsung.replaceAll(
                        "\n",
                        "<br />"
                      )}
                      rehypePlugins={[rehypeRaw]}
                    />
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={2}>
                    Kemungkinan Penyebab Dasar :
                  </td>
                  <td style={styles.td} colSpan={10}>
                    <ReactMarkdown
                      children={inputFields.kemungkinanPenyebabDasar.replaceAll(
                        "\n",
                        "<br />"
                      )}
                      rehypePlugins={[rehypeRaw]}
                    />
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={2}>
                    Immediate Action yang sudah dilakukan :
                  </td>
                  <td style={styles.td} colSpan={10}>
                    <ReactMarkdown
                      children={inputFields.immadiateAction.replaceAll(
                        "\n",
                        "<br /> "
                      )}
                      rehypePlugins={[rehypeRaw]}
                    />
                  </td>
                </tr>

                {/* <tr style={styles.tr}>
                  <td style={styles.td} colSpan={3}>
                    Upload Document :
                  </td>
                  <td style={styles.td} colSpan={10}>
                    <b>
                      * upload file (PDF, Word, Excel, PPT, Photo file) (Maximum
                      10 Mb)
                    </b>
                  </td>
                </tr> */}
              </>

              {/* Footer */}
              <>
                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={6} rowSpan={2}></td>
                  <td style={styles.tdCenter} colSpan={7}>
                    Dilaporkan Oleh:
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.tdCenter} colSpan={7}>
                    {inputFields.jabatanPembuatDokumen}
                  </td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.tdBlank} colSpan={6}>
                    {" "}
                  </td>
                  <td style={styles.tdBlank} colSpan={7}>
                    {" "}
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={6}>
                    {" "}
                  </td>
                  <td style={styles.tdCenter} colSpan={7}>
                    {inputFields.namaPembuatDokumen}
                  </td>
                </tr>

                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={6}>
                    {" "}
                  </td>
                  <td style={styles.tdBottomLeft} colSpan={7}>
                    {" "}
                  </td>
                </tr>

                {/* ini dikasi if jika inputFields.listTembusan != null dan inputFields.listTembusan length > 0 baru dimunculkan */}
                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1}>
                    Tembusan :
                  </td>
                  <td style={styles.td} colSpan={11}>
                    {inputFields.listTembusan.map((item, idx) => (
                      <>
                        {item.seq}. {item.jabatanUser} <br></br>
                      </>
                    ))}
                  </td>
                </tr>
              </>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

const styles = {
  btnExport: {
    float: "right",
  },
  page: {
    // backgroundColor: "lightgrey",
    // padding: "30px",
    marginTop: "-30px",
    paddingLeft: "30px",
    paddingRight: "30px",
    paddingBottom: "30px",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: "120px",
    alignItems: "center",
    marginBottom: "-30px",
  },
  title: {
    // marginLeft: "30px",
    fontSize: "28px",
    fontWeight: "600",
  },
  subtitle: {
    textAlign: "center",
    fontWeight: "800",
    fontSize: "13px",
    border: "1px solid black",
    backgroundColor: "lightGrey",
    // height: "35px",
  },
  logo: {
    height: "60px",
    width: "auto",
  },
  table: {
    fontFamily: "arial",
    borderCollapse: "collapse",
    fontSize: "10px",
    width: "100%",
  },
  td: {
    border: "1px solid black",
    padding: "3.5px 10px",
  },
  tdBlank: {
    height: "150px",
    border: "1px solid black",
  },
  tdCenter: {
    textAlign: "center",
    border: "1px solid black",
    padding: "3.5px 10px",
    fontWeight: "600",
  },
  tdBottomLeft: {
    textAlign: "bottom",
    border: "1px solid black",
    padding: "3.5px 10px",
    fontWeight: "600",
  },
};

export default LKPToPDF;
